import React from "react";

export const Crypto = () => {
  const isMobile = window.innerWidth <= 768; // Check if the screen width is mobile size
  return (
    <div className="decentralized mb-5">
      <div className="container" data-aos="fade-up"
        data-aos-delay="500">
        {isMobile ? <div style={{ display: "flex", flexDirection: "column" }}>
          <h2 style={{ flex: 1 }}>
            The Rise of Crypto-Backed Stablecoins: The Stabolut Story
          </h2>
          <a className="mb-3" href="https://onchain.org/magazine/the-rise-of-crypto-backed-stablecoins-the-stabolut-story/" target="_blank"><button className="btn-black">Read Report </button></a>

          <a href="https://onchain.org/magazine/the-rise-of-crypto-backed-stablecoins-the-stabolut-story/" target="_blank">
            <img src="/images/Frame43.png" alt="decent" className="img-fluid me-3 mb-3 mb-md-0" />
          </a>

          <h2 style={{ flex: 1 }}>
            Pioneering Decentralised Stability in the Volatile World of Crypto


          </h2>
          <a className="mb-3" href="https://www.coinsilium.com/investors/web3-reports/download-file?path=8.%2BStabolut%2BPioneering%2BDecentralised%2BStability%2Bin%2Bthe%2BVolatile%2BWorld%2Bof%2BCrypto.pdf" target="_blank"><button className="btn-black">Read Report </button></a>
          <a href="https://www.coinsilium.com/investors/web3-reports/download-file?path=8.%2BStabolut%2BPioneering%2BDecentralised%2BStability%2Bin%2Bthe%2BVolatile%2BWorld%2Bof%2BCrypto.pdf" target="_blank">
            <img src="/images/Frame44.png" alt="decent" className="img-fluid me-3 mb-3 mb-md-0" />
          </a>

        </div> :
          <div data-aos="fade-up"
            data-aos-delay="500" style={{ display: "flex", flexDirection: "row" }}>


            <div style={{ display: "flex", flex: 3.19, justifyContent: "flex-end" }}>
              <a href="https://onchain.org/magazine/the-rise-of-crypto-backed-stablecoins-the-stabolut-story/"  target="_blank">
                <img src="/images/Frame43.png" alt="decent" className="img-fluid me-3 mb-3 mb-md-0" />
              </a>

            </div>
            <div style={{ display: "flex", flex: 6, flexDirection: "column" }}>


              <div style={{ display: "flex", flexDirection: "row", alignItems: "center", flex: 1, padding: 16 }}>
                <h2 className="me-3" style={{ flex: 1 }}>
                  Pioneering Decentralised Stability in the Volatile World of Crypto
                </h2>
                <a href="https://www.coinsilium.com/investors/web3-reports/download-file?path=8.%2BStabolut%2BPioneering%2BDecentralised%2BStability%2Bin%2Bthe%2BVolatile%2BWorld%2Bof%2BCrypto.pdf" target="_blank"><button className="btn-black">Read Report →  </button></a>
              </div>

              <div style={{ display: "flex", flexDirection: "row", alignItems: "center", flex: 1, padding: 16 }}>
                <a className="me-3" href="https://onchain.org/magazine/the-rise-of-crypto-backed-stablecoins-the-stabolut-story/" target="_blank"><button className="btn-black">← Read Report </button></a>
                <h2 className="text-end" style={{ flex: 1 }}>
                  The Rise of Crypto-Backed Stablecoins: The Stabolut Story

                </h2>
              </div>


            </div>

            <div style={{ display: "flex", flex: 3.19, justifyContent: "center" }}>

              <a href="https://www.coinsilium.com/investors/web3-reports/download-file?path=8.%2BStabolut%2BPioneering%2BDecentralised%2BStability%2Bin%2Bthe%2BVolatile%2BWorld%2Bof%2BCrypto.pdf" target="_blank">
                <img src="/images/Frame44.png" alt="decent" className="img-fluid me-3 mb-3 mb-md-0" />
              </a>

            </div>

          </div>
        }
      </div>

    </div>
  );
};
